import React from 'react'



const Footer=()=>{
    return(
        <div className='footer'>
            <hr />
            <div>
                تمامی حقوق معنوی و مادی این سایت متعلق به نیو وبینار میباشد
            </div>
        </div>
    )
}


export default Footer